import React from "react";

export const LecturePlayIcon = ({ size = 24, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M19.8764 11.1891C20.4295 11.5883 20.4295 12.4117 19.8764 12.8109L9.08521 20.5988C8.42384 21.0761 7.5 20.6035 7.5 19.7879L7.5 4.21212C7.5 3.39651 8.42384 2.92394 9.08521 3.40124L19.8764 11.1891Z"
      fill="white"
    />
  </svg>
);

export const LecturePauseIcon = ({ size = 24, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <rect x="7.5" y="5" width="3.5" height="14" rx="0.75" fill="white" />
    <rect x="13" y="5" width="3.5" height="14" rx="0.75" fill="white" />
  </svg>
);

export const LecturePrevNavIcon = ({ size = 20, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M6.18645 7.17801C5.61244 7.57569 5.61244 8.42431 6.18645 8.82199L10.9305 12.1088C11.5937 12.5683 12.5 12.0936 12.5 11.2868L12.5 4.71322C12.5 3.9064 11.5937 3.43175 10.9305 3.89123L6.18645 7.17801Z"
      fill="#222222"
    />
    <rect x="3" y="3" width="2" height="10" rx="1" fill="#222222" />
  </svg>
);

export const LectureNextNavIcon = ({ size = 20, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M9.81355 7.17801C10.3876 7.57569 10.3876 8.42431 9.81355 8.82199L5.06949 12.1088C4.40629 12.5683 3.5 12.0936 3.5 11.2868L3.5 4.71322C3.5 3.9064 4.40629 3.43175 5.0695 3.89123L9.81355 7.17801Z"
      fill="#222222"
    />
    <rect x="11" y="3" width="2" height="10" rx="1" fill="#222222" />
  </svg>
);

export const LecturePrevIcon = ({ size = 16, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M6.18645 7.17801C5.61244 7.57569 5.61244 8.42431 6.18645 8.82199L10.9305 12.1088C11.5937 12.5683 12.5 12.0936 12.5 11.2868L12.5 4.71322C12.5 3.9064 11.5937 3.43175 10.9305 3.89123L6.18645 7.17801Z"
      fill="white"
    />
    <rect x="3" y="3" width="2" height="10" rx="1" fill="white" />
  </svg>
);

export const LectureNextIcon = ({ size = 16, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M9.81355 7.17801C10.3876 7.57569 10.3876 8.42431 9.81355 8.82199L5.06949 12.1088C4.40629 12.5683 3.5 12.0936 3.5 11.2868L3.5 4.71322C3.5 3.9064 4.40629 3.43175 5.0695 3.89123L9.81355 7.17801Z"
      fill="white"
    />
    <rect x="11" y="3" width="2" height="10" rx="1" fill="white" />
  </svg>
);

export const LectureVolumeMuteIcon = ({ size = 20, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M5.625 6.87491L9.55834 2.94157C9.64574 2.85428 9.75706 2.79484 9.87822 2.77077C9.99939 2.7467 10.125 2.75907 10.2391 2.80633C10.3532 2.85359 10.4508 2.93362 10.5195 3.0363C10.5882 3.13898 10.6249 3.25971 10.625 3.38324V16.6166C10.6249 16.7401 10.5882 16.8608 10.5195 16.9635C10.4508 17.0662 10.3532 17.1462 10.2391 17.1935C10.125 17.2407 9.99939 17.2531 9.87822 17.229C9.75706 17.205 9.64574 17.1455 9.55834 17.0582L5.625 13.1249H3.75834C3.025 13.1249 2.33834 12.7024 2.14334 11.9966C1.96459 11.3461 1.87434 10.6745 1.875 9.99991C1.875 9.30824 1.96834 8.63907 2.14334 8.00324C2.33834 7.29657 3.025 6.87491 3.75834 6.87491H5.625Z"
      fill="white"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.166 6.66699L17.4993 10.0003M17.4993 6.66699L14.166 10.0003"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LectureVolumeIcon = ({ size = 20, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M5.625 6.87491L9.55834 2.94157C9.64574 2.85428 9.75706 2.79484 9.87822 2.77077C9.99939 2.7467 10.125 2.75907 10.2391 2.80633C10.3532 2.85359 10.4508 2.93362 10.5195 3.0363C10.5882 3.13898 10.6249 3.25971 10.625 3.38324V16.6166C10.6249 16.7401 10.5882 16.8608 10.5195 16.9635C10.4508 17.0662 10.3532 17.1462 10.2391 17.1935C10.125 17.2407 9.99939 17.2531 9.87822 17.229C9.75706 17.205 9.64574 17.1455 9.55834 17.0582L5.625 13.1249H3.75834C3.025 13.1249 2.33834 12.7024 2.14334 11.9966C1.96459 11.3461 1.87434 10.6745 1.875 9.99991C1.875 9.30824 1.96834 8.63907 2.14334 8.00324C2.33834 7.29657 3.025 6.87491 3.75834 6.87491H5.625Z"
      fill="white"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9279 4.69629C16.6244 5.39273 17.1768 6.21953 17.5537 7.12947C17.9307 8.03942 18.1246 9.0147 18.1246 9.99962C18.1246 10.9845 17.9307 11.9598 17.5537 12.8698C17.1768 13.7797 16.6244 14.6065 15.9279 15.303M13.7188 6.90629C14.5391 7.72674 14.9999 8.83943 14.9999 9.99962C14.9999 11.1598 14.5391 12.2725 13.7188 13.093"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LectureExpandIcon = ({ size = 20, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M8.92792 8.9289L4.16602 4.16699M4.16602 7.97652V4.16699H7.97554M11.7851 11.786L16.547 16.5479M16.547 12.7384V16.5479H12.7374"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LectureCompressIcon = ({ size = 20, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M7.97867 9.45697L4.40883 9.45417L4.40726 11.4542L11.4073 11.4597L11.4127 4.45966L9.41274 4.45809L9.40992 8.05972L3.09616 1.76929L1.68457 3.18612L7.97867 9.45697Z"
      fill="white"
    />
    <path
      d="M19.5615 14.5521L19.5535 12.5521L12.5536 12.5799L12.5814 19.5799L14.5814 19.5719L14.5671 15.9705L20.9105 22.2306L22.3153 20.8071L15.9914 14.5663L19.5615 14.5521Z"
      fill="white"
    />
  </svg>
);

export const LectureInfoIcon = ({ size = 18, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <g clipPath="url(#lecture_info_clip)">
      <path
        d="M9 12V9M9 6H9.0075M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="lecture_info_clip">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LectureCompletedIcon = ({ size = 16, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <rect width="16" height="16" rx="8" fill="#3E8B63" />
    <path
      d="M4 7.69961L7.38462 11.1996L12.8 5.59961"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LectureUnwatchedIcon = ({ size = 16, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <g clipPath="url(#lecture_unwatched_clip)">
      <path
        d="M8.00065 14.6663C11.6825 14.6663 14.6673 11.6816 14.6673 7.99967C14.6673 4.31778 11.6825 1.33301 8.00065 1.33301C4.31875 1.33301 1.33398 4.31778 1.33398 7.99967C1.33398 11.6816 4.31875 14.6663 8.00065 14.6663Z"
        stroke="#999999"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33398 5.97666C6.33398 5.65847 6.33398 5.49938 6.40048 5.41056C6.45843 5.33316 6.54713 5.28473 6.64357 5.27784C6.75424 5.26994 6.88807 5.35597 7.15572 5.52803L10.3028 7.55115C10.535 7.70045 10.6512 7.77511 10.6913 7.87003C10.7263 7.95298 10.7263 8.04657 10.6913 8.12951C10.6512 8.22444 10.535 8.29909 10.3028 8.4484L7.15572 10.4715C6.88807 10.6436 6.75424 10.7296 6.64357 10.7217C6.54713 10.7148 6.45843 10.6664 6.40048 10.589C6.33398 10.5002 6.33398 10.3411 6.33398 10.0229V5.97666Z"
        fill="#999999"
        stroke="#999999"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="lecture_unwatched_clip">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LectureBackIcon = ({ size = 24, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M20 12H4M10 6L4 12L10 18"
      stroke="#222222"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LectureSettingsIcon = ({ size = 16, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M6.26271 12.9137L6.65234 13.79C6.76817 14.0509 6.95719 14.2725 7.19649 14.4281C7.43579 14.5836 7.71508 14.6664 8.00049 14.6663C8.2859 14.6664 8.56519 14.5836 8.80449 14.4281C9.04378 14.2725 9.23281 14.0509 9.34864 13.79L9.73826 12.9137C9.87696 12.6028 10.1103 12.3436 10.4049 12.173C10.7015 12.002 11.0445 11.9291 11.3849 11.9649L12.3383 12.0663C12.622 12.0964 12.9084 12.0434 13.1627 11.9139C13.417 11.7844 13.6283 11.5839 13.7709 11.3367C13.9136 11.0897 13.9817 10.8065 13.9667 10.5216C13.9517 10.2367 13.8543 9.96221 13.6864 9.73153L13.122 8.95597C12.921 8.67776 12.8136 8.34288 12.8153 7.99967C12.8152 7.6574 12.9236 7.32391 13.1249 7.04708L13.6894 6.27153C13.8573 6.04084 13.9547 5.76639 13.9696 5.48146C13.9846 5.19653 13.9166 4.91337 13.7738 4.66634C13.6312 4.41916 13.42 4.21867 13.1657 4.08916C12.9114 3.95965 12.625 3.90669 12.3412 3.93671L11.3879 4.03819C11.0474 4.07395 10.7044 4.00109 10.4079 3.83004C10.1126 3.65851 9.87928 3.39791 9.74123 3.0856L9.34864 2.2093C9.23281 1.94846 9.04378 1.72682 8.80449 1.57127C8.56519 1.41573 8.2859 1.33296 8.00049 1.33301C7.71508 1.33296 7.43579 1.41573 7.19649 1.57127C6.95719 1.72682 6.76817 1.94846 6.65234 2.2093L6.26271 3.0856C6.12466 3.39791 5.89129 3.65851 5.59604 3.83004C5.29952 4.00109 4.95649 4.07395 4.61604 4.03819L3.65975 3.93671C3.37597 3.90669 3.08957 3.95965 2.83529 4.08916C2.58101 4.21867 2.36976 4.41916 2.22715 4.66634C2.08437 4.91337 2.01634 5.19653 2.03133 5.48146C2.04632 5.76639 2.14368 6.04084 2.3116 6.27153L2.87604 7.04708C3.07734 7.32391 3.18574 7.6574 3.18567 7.99967C3.18574 8.34195 3.07734 8.67544 2.87604 8.95227L2.3116 9.72782C2.14368 9.9585 2.04632 10.233 2.03133 10.5179C2.01634 10.8028 2.08437 11.086 2.22715 11.333C2.3699 11.5801 2.58117 11.7804 2.83542 11.9099C3.08967 12.0394 3.37599 12.0925 3.65975 12.0626L4.61308 11.9612C4.95353 11.9254 5.29656 11.9983 5.59308 12.1693C5.88943 12.3404 6.12389 12.601 6.26271 12.9137Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.9993 9.99967C9.10387 9.99967 9.9993 9.10424 9.9993 7.99967C9.9993 6.8951 9.10387 5.99967 7.9993 5.99967C6.89473 5.99967 5.9993 6.8951 5.9993 7.99967C5.9993 9.10424 6.89473 9.99967 7.9993 9.99967Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LectureCloseIcon = ({ size = 28, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M21 7L7 21M7 7L21 21"
      stroke="#222222"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LectureChevronUpIcon = ({ size = 18, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M4.5 11.25L9 6.75L13.5 11.25"
      stroke="#767676"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LectureChevronDownIcon = ({ size = 18, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M4.5 6.75L9 11.25L13.5 6.75"
      stroke="#767676"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
